class ElementHelper {
  #element

  constructor(element) {
    this.#element = element
  }

  /**
   * Checks if the element contains **all** of the specified CSS classes.
   * 
   * @param {...(string|Array<string>)} args - CSS classes to check. Supports:
   * - Individual strings: `'class1', 'class2'`
   * - Arrays: `['class1', 'class2']`
   * - Mix: `'class1', ['class2', 'class3']`
   * - Nested arrays (flattened): `['class1', ['class2', ['class3']]]`
   * 
   * @returns {boolean} `true` if the element contains **all** classes, otherwise `false`.
   * 
   * @example
   * // Basic cases
   * element.hasAllClasses('active', 'visible')
   * element.hasAllClasses(['active', 'visible'])
   * element.hasAllClasses('active', ['visible', 'hover'])
   * 
   * // Nested arrays
   * element.hasAllClasses(['overflow-auto', ['max-w-full', 'block']])
   * 
   * // Empty/falsy values are ignored
   * element.hasAllClasses('', null, 'active', undefined)
   */
  hasAllClasses(...args) {
    const classes = args.flat(Infinity).filter(Boolean)

    return classes.every(className => this.#element.classList.contains(className))
  }
}

export default (element) => new ElementHelper(element)
